<template>
  <ContactsContainer />
</template>

<script lang="ts">
import Vue from "vue";
import ContactsContainer from "@/components/projects/project/contacts/container/ContactsContainer.vue";

export default Vue.extend({
  components: {
    ContactsContainer,
  },
});
</script>
